import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SidebarRoutingModule } from './sidebar-routing.module';
import { SidebarComponent } from './sidebar.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { BlankPageModule } from '../../blank-page/blank-page.module';
import { FormModule } from '../../encs/form/form.module';
import { InstitucionesModule } from '../../instituciones/instituciones.module';

@NgModule({
  imports: [
    CommonModule,
    SidebarRoutingModule,
    TranslateModule,
    NgbDropdownModule,
    BlankPageModule,
    FormModule,
    InstitucionesModule
  ],
  declarations: [SidebarComponent],
  exports: [SidebarComponent]

})
export class SidebarModule { }
